import { render, staticRenderFns } from "./suppliergrouppurchase.vue?vue&type=template&id=9bdafc3a&scoped=true&"
import script from "./suppliergrouppurchase.vue?vue&type=script&lang=js&"
export * from "./suppliergrouppurchase.vue?vue&type=script&lang=js&"
import style0 from "./suppliergrouppurchase.vue?vue&type=style&index=0&id=9bdafc3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdafc3a",
  null
  
)

export default component.exports